import { useEffect } from "react";
import useAbortLikeError from "./useAbortLikeError";

export default function useAbortLikeUnhandledRejection() {
  const isAbortLikeError = useAbortLikeError();

  useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (isAbortLikeError(event.reason)) {
        event.preventDefault();
      }
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, [isAbortLikeError]);
}

